export default __webpack_public_path__ + "static/media/bg-blue.324449ec.svg";